/**
 * Constants for AuditLogViewerAuditorSmartFilters component
 */
// Tab configuration
export const TAB_CONFIG = {
  'review-details': {
    label: 'Review Details',
    value: 'review-details',
  },
  'request-details': {
    label: 'Request Details',
    value: 'request-details',
  },
} as const;

// CSS class names
export const CSS_CLASSES = {
  ROOT: 'AuditLogViewerAuditorSmartFilters',
  HEADER: 'AuditLogViewerAuditorSmartFilters-header',
  TABS: 'AuditLogViewerAuditorSmartFilters-tabs',
  CLOSE_BUTTON: 'AuditLogViewerAuditorSmartFilters-closeButton',
  BODY: 'AuditLogViewerAuditorSmartFilters-body',
  SESSION: 'AuditLogViewerAuditorSmartFilters-session',
  CONTENT: 'AuditLogViewerAuditorSmartFilters-content',
  FIELD: 'AuditLogViewerAuditorSmartFilters-field',
  FIELD_FIRST: 'AuditLogViewerAuditorSmartFilters-fieldFirst',
  FIELD_LABEL: 'AuditLogViewerAuditorSmartFilters-fieldLabel',
  ACTIVITY_LIST: 'AuditLogViewerAuditorSmartFilters-activityList',
  ACTIVITY_LIST_FRAME: 'AuditLogViewerAuditorSmartFilters-activityList-frame',
  ACTIVITY_ITEM: 'AuditLogViewerAuditorSmartFilters-activityItem',
  ACTIVITY_ICON: 'AuditLogViewerAuditorSmartFilters-activityIcon',
  ACTIVITY_ARROW: 'AuditLogViewerAuditorSmartFilters-activityArrow',
  REVIEWER: 'AuditLogViewerAuditorSmartFilters-reviewer',
  COMMENTS: 'AuditLogViewerAuditorSmartFilters-comments',
} as const;
